import React, { Component } from 'react';
import {
    Input, InputNumber, Button, Form,
} from 'antd';

import ThankModal from './ThankModal';

const FormItem = Form.Item;

class UnwrappedMsgOptPage extends Component {
    state = {
        loading: false,
        thankModal: false,
    };

    showModal = () => {
        this.setState({
            thankModal: true,
        });
    }

    showModalCancel = () => {
        this.setState({
            thankModal: false,
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                console.log(values);
                form.resetFields();
                this.showModal();
            }
        });
    };

    render() {
        const { form } = this.props;
        const { loading, thankModal } = this.state;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 },
            },
        };

        return (
            <div style={{
                width: '75%', margin: 'auto', marginTop: '8%', textAlign: 'center',
            }}
            >

                <h4 style={{ textAlign: 'center' }}>Sign Up For Caredose</h4>
                <hr width="200px" />

                <br /><br />

                <p style={{ fontSize: '1.2em' }}>
                    If you want to Opt for SMS notifications, please fill in your Mobile Number below and submit
                    to start getting notifications!
                </p>

                <br />

                <div>

                    <Form onSubmit={this.handleSubmit}>

                        <FormItem
                            {...formItemLayout}
                            label="Name"
                        >
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Please fill in your name!!' }],
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Mobile Number"
                        >
                            {getFieldDecorator('number', {
                                rules: [{ required: true, message: 'Number is important!' }],
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Submit
                        </Button>

                    </Form>

                </div>

                <ThankModal
                    visible={thankModal}
                    onCancel={this.showModalCancel}
                />

            </div>
        );
    }
}

const MsgOptPage = Form.create()(UnwrappedMsgOptPage);

export default MsgOptPage;



// WEBPACK FOOTER //
// ./src/component/MsgOptPage/MsgOptPage.js